import type { ReactNode } from 'react';

export function CapabilityNotice({ allowed, children }: { allowed: boolean; children: ReactNode }) {
  if (allowed) {
    return null;
  }
  return <p className="capability-notice">{children}</p>;
}
